import { CalendarIcon, DownArrowIcon } from "@xola/icons";
import { Skeleton } from "@xola/ui-kit";
import { now } from "common";
import React from "react";

export const ArrivalPickerSkeleton = () => {
    return (
        <div>
            <div className="space-y-1">
                <span className="text-sm font-bold">Date</span>
                <Skeleton height={40} classNames={{ container: " !justify-start  w-60" }}>
                    <div className="flex w-60 items-center rounded border border-gray-light bg-gray-lighter py-2.5 pl-9 pr-8">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                            <CalendarIcon />
                        </div>

                        <div>{now().format("ddd, LL")}</div>

                        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                            <DownArrowIcon />
                        </div>
                    </div>
                </Skeleton>
            </div>
            <div className="grid grid-cols-3 gap-2">
                <ButtonSkeleton />
                <ButtonSkeleton />
                <ButtonSkeleton />
            </div>
        </div>
    );
};

const ButtonSkeleton = () => (
    <Skeleton height={45} classNames={{ container: "mt-4" }}>
        <div className="inline-flex h-10 items-center justify-center whitespace-nowrap rounded px-10 py-4 leading-base ">
            <div className="m-1 space-y-1">
                <div className="h-3 w-20 bg-gray-light" />
                <div className="mx-auto h-3 w-12 bg-gray-light" />
            </div>
        </div>
    </Skeleton>
);
